var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "artistic-concept", attrs: { "lazy-validation": "" } },
    [
      _c(
        "v-row",
        { staticClass: "px-5" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v(
                  "32. Mein künstlerisches Konzept fällt am ehesten in die Kategorie (wenn nicht zuordbar sonstige auswählen)"
                )
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.rechercheprojekte))
                  ])
                : _c("v-select", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      placeholder: "Bitte Auswählen!",
                      "persistent-placeholder": "",
                      items: _vm.concepts,
                      rules: [_vm.rules.required]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("rechercheprojekte", v)
                      }
                    },
                    model: {
                      value: _vm.formData.rechercheprojekte,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "rechercheprojekte", $$v)
                      },
                      expression: "formData.rechercheprojekte"
                    }
                  })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "primary--text" }, [
                _vm._v("33. Künstlerisches Konzept/Projektskizze")
              ]),
              _c("div", { staticClass: "hint-label mb-1" }, [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(
                    "Beschreiben Sie Ihre Idee/Ihr Konzept, für die künstlerische Tätigkeit, die durch das Stipendium ermöglicht werden soll (maximal 2.000 Zeichen ohne. Leerzeichen Text ohne Textauszeichnung wie Überschriften, Gliederungen etc.). Entscheidend sind die Ziele und Wege, wie die Ziele erreicht werden sollen. "
                  ),
                  _c("br"),
                  _vm._v(
                    "Die Beschreibung sollte u. a. folgende Angaben enthalten:"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n- Titel für die künstlerische Tätigkeit bzw. das Projekt oder die Maßnahme,"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n- Ziel, Ergebnis: Was möchten Sie tun? Wie möchten Sie das Ziel erreichen?"
                  ),
                  _c("br"),
                  _vm._v("\n- Ggf. mit wem möchten Sie zusammenarbeiten?"),
                  _c("br"),
                  _vm._v("\n- Wen möchten Sie mit diesem Projekt erreichen?"),
                  _c("br"),
                  _vm._v(
                    "\n- Welchen zeitlichen Rahmen haben Sie für das Projekt vorgesehen?"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n- Wie bzw. in welcher Form ist eine Dokumentation des Projektverlaufs und des Ergebnisses vorgesehen?"
                  )
                ])
              ]),
              _vm.readonly
                ? _c("p", { staticClass: "text-preview" }, [
                    _vm._v(_vm._s(_vm.formData.kuenstlerisches_konzept))
                  ])
                : _c("v-textarea", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      rows: 5,
                      rules: [_vm.rules.required, _vm.rules.maxLen(2000)]
                    },
                    on: {
                      input: function(v) {
                        return _vm.saveFieldValue("kuenstlerisches_konzept", v)
                      }
                    },
                    model: {
                      value: _vm.formData.kuenstlerisches_konzept,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "kuenstlerisches_konzept", $$v)
                      },
                      expression: "formData.kuenstlerisches_konzept"
                    }
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }